export default __webpack_public_path__ + "static/media/Dang Pa.00d43873.jpg";